import type { ProfileRepository } from '../../../application/ports/ProfileRepository';
import type { Profile } from '../../../domain/profile/Profile';
import type { ProfileId } from '../../../domain/shared/ids';
import type { AscendInvictusDatabase } from '../AscendInvictusDatabase';
import { ProfileMapper } from '../mappers';
import { executePersistence } from '../translatePersistenceError';

export class DexieProfileRepository implements ProfileRepository {
  public constructor(private readonly database: AscendInvictusDatabase) {}

  public save(profile: Profile): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.profiles.put(ProfileMapper.toRecord(profile));
    });
  }

  public findById(id: ProfileId): Promise<Profile | null> {
    return executePersistence('read', async () => {
      const record = await this.database.profiles.get(id);
      return record ? ProfileMapper.fromRecord(record) : null;
    });
  }

  public list(): Promise<readonly Profile[]> {
    return executePersistence('read', async () =>
      (await this.database.profiles.toArray()).map((record) => ProfileMapper.fromRecord(record)),
    );
  }

  public delete(id: ProfileId): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.profiles.delete(id);
    });
  }
}
